import styled from 'styled-components';

export const SortingOuterWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    height: 5rem;
    background-color: ${props.theme.colors.white.bgWhite};
    padding: ${props.theme.spacing.large.l12} ${props.theme.spacing.nospacing} ${props.theme.spacing.large.l16};
    position: sticky;
    top: 6.8rem;
    z-index: 1;
  `
);

export const SortingText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font16};
    color: ${props.theme.colors.grey.base};
    padding-right: ${props.theme.spacing.small.s5};
  `
);

export const SortSelectedText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font16};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    display: flex;
    align-items: center;
    cursor: pointer;
  `
);

export const HiddenDropdownWrapperDiv = styled.div(
  props => `
    width: 17rem;
    top: ${props => props.top || props.theme.spacing.large.l15};
    right: ${props => props.right || '0'};
    max-width: ${props => props.right || '30rem'};
    padding: ${props => props.theme.spacing.base} 0;
    z-index: ${props => props.theme.misc.zIndex.base};
    visibility: hidden;
    transition: opacity 0.8s;
    position: absolute;
    top: 2.2rem;
    right: 0rem;
  `
);

export const SelctedTextWrap = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  text-align: left;
  display: inline-flex;
  &:hover ${HiddenDropdownWrapperDiv} {
    visibility: visible;
  }
`;

export const TopDiv = styled.div(
  props => `
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.base};
    box-shadow: 0 ${props.theme.spacing.small.s1} ${props.theme.spacing.small.s4} ${
    props.theme.colors.shadow.base
  };
`,
);

export const ListDropDownWrapper = styled.div(
  props => `
    width: 100%;
    display: flex;
    list-style-type: none;
    overflow: hidden;
    padding: ${props.theme.spacing.small.s5} 0 0;
    flex-direction: column;
    > li {
      width: 100%;
      display: flex;
      flex-direction: row;
      border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
      padding: ${props.theme.spacing.base};
      position: relative;
      cursor: pointer;
      &:last-child {
        border-bottom: none;
      }
    }
`,
);

export const RadioCheck = styled.input.attrs({type: 'radio'})(
  props => `
    width: 2rem;
    height: 2rem;
    align-items: center;
    justify-content: center;
    margin-right: ${props.theme.spacing.small.s5};
    border-radius: 50%;
    display: inline-block;
    cursor: pointer;

    :checked:after {
        border-radius: 5rem;
        content: " ";
        height: 1.4rem;
        position: absolute;
        width: 1.4rem;
        top: 1.2rem;
        left: 1.2rem;
    }
  `
);

export const FontBigBold = styled.span(
  props => `
    font-size: ${props.theme.font.large.font14};
  `
);

const TipUI = styled.div`
  position: absolute;
  margin-left: -${props => props.theme.spacing.base};
  width: 2.4rem;
  height: 1.2rem;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    width: 1.3rem;
    height: 1.2rem;
    left: 50%;
    background: white;
  }
`;

export const TipPositioning = styled(TipUI)`
  right: 15%;
  top: -1.2rem;
  &::after {
    transform: translate(-50%, 50%) rotate(45deg);
    background: ${props => props.bgColor};
    box-shadow: 0 ${props => props.theme.spacing.small.s1} ${props => props.theme.spacing.small.s4}
      ${props => props.theme.colors.shadow.base};
  }
`;
